<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content>
			<template #content>
				<div class="columns column12">
					<div class="title-reverse-wrapper">
						<h1>{{ page.header }}</h1>
						<h2 class="subtitle">{{ page.subtitle }}</h2>
					</div>
					<div v-parse-links v-html="page.content" />
					<p>
						<font-awesome-icon icon="fa-regular fa-location-dot" size="1x" />&nbsp;
						<strong>{{ defaults[locale].website.hotelName }}</strong>
						<br />
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<br />
						<span>{{ defaults[locale].website.country }}</span>
						<br />
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<span>T: {{ defaults[locale].website.phone }}</span>
						</a>
						<br />
						<a :href="`mailto:${defaults[locale].website.email}`">
							<span>E: {{ defaults[locale].website.email }}</span>
						</a>
					</p>
				</div>
			</template>
		</main-content>
		<section class="main-content background-light">
			<div class="row contact-form-row">
				<div class="columns column6 contact-form-col">
					<h2>{{ $t('contactFormHeader') }}</h2>
					<contact-form name="contact" :form="form" />
				</div>
				<div class="columns column6 maps">
					<iframe
						id="maps"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2518.118076461159!2d5.833699976915705!3d50.86601375735523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c095557a973387%3A0x4b8e595b0e913dab!2sSteenstraat%202%2C%206301%20ED%20Valkenburg!5e0!3m2!1snl!2snl!4v1687945229660!5m2!1snl!2snl"
						width="100%"
						height="450"
						style="border: 0"
						allowfullscreen=""
						loading="lazy"
					/>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style lang="scss" scoped>
.contact-form-col {
	padding: 50px;
}

.maps {
	padding: 20px;
}

#maps {
	min-height: 600px;
}
</style>
